import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import colors from "../../../shared/themes/colors";

export interface ViewServiceRequestSectionCardProps {
  children?: ReactNode;
}

const ViewServiceRequestSectionCard = ({ children }: ViewServiceRequestSectionCardProps) => {
  return (
    <Box
      className="flex flex-col self-start p-4"
      sx={{
        background: colors.primary.white1,
        border: `1px solid ${colors.secondary.gray94}`,
        borderRadius: "16px",
        width: "100%"
      }}
    >
      {children}
    </Box>
  );
};

export default ViewServiceRequestSectionCard;
